/**
 * @generated SignedSource<<783083d2664c3d4615c34b35690b8777>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MissionControlActivateSageIntacctInput = {
  companyId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type MissionControlActivateSageIntacctMutation$variables = {
  input: MissionControlActivateSageIntacctInput;
};
export type MissionControlActivateSageIntacctMutation$data = {
  readonly MissionControlActivateSageIntacct: {
    readonly outcome: string | null;
    readonly errorMessage: string | null;
  } | null;
};
export type MissionControlActivateSageIntacctMutation = {
  variables: MissionControlActivateSageIntacctMutation$variables;
  response: MissionControlActivateSageIntacctMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MissionControlActivateSageIntacctPayload",
    "kind": "LinkedField",
    "name": "MissionControlActivateSageIntacct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MissionControlActivateSageIntacctMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MissionControlActivateSageIntacctMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4f7868402585ec15f0d025ab3c64bcd2",
    "id": null,
    "metadata": {},
    "name": "MissionControlActivateSageIntacctMutation",
    "operationKind": "mutation",
    "text": "mutation MissionControlActivateSageIntacctMutation(\n  $input: MissionControlActivateSageIntacctInput!\n) {\n  MissionControlActivateSageIntacct(input: $input) {\n    outcome\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "59c4e567962df13777f88e4420ad7766";

export default node;
